module.exports = __webpack_public_path__ + "img/spain-cancer-male.316bd9ab.png";